export default {
  INIT_CLIENT: 'INIT_CLIENT',
  INIT_WORKSHOP: 'INIT_WORKSHOP',
  INIT_WORKSHOP_WITH_CLIENT: 'INIT_WORKSHOP_WITH_CLIENT',
};
